export default __webpack_public_path__ + "static/media/campaign_cover.ece48d73.png";